__turbopack_context__.v({
  "root": "AnimatedIcon-module-scss-module___KNZ5a__root",
});
